import React from "react";
import {Link} from "react-router-dom";
// import './Services.css'
// import videoBG from '../assets/videoBg.mp4'
import servicesPageBanner from '../assets/bannerImages/servicesPageBanner.webp'

import whatsAppMarketingBanner from '../assets/bannerImages/WhatsAppMarketingBanner.webp'
import websiteDevelopmentImage from '../assets/bannerImages/websiteDevelopment.jpg'
import socialMediaMarketingImage from '../assets/bannerImages/socialMediaMarketing.webp'
import videoAdsBanner from '../assets/bannerImages/videoAdsBanner.jpg'
import onlineGrowth from '../assets/bannerImages/onlineGrowth.jpg'
import searchEngineOptimization from '../assets/bannerImages/searchEngineOptimization.jpg'
import emailMarketing from '../assets/bannerImages/emailMarketing.jpg'
import influencerMarketing from '../assets/bannerImages/influencerMarketing.jpg'
import payPerClickAds from '../assets/bannerImages/payPerClickMarketing.jpg'
// import ServicesNav from "./ServicesNav";
// import ContactSection from '../components/services/SocialMediaMarketing'

import bulkSMS from '../assets/images/bulkSMS.jpg'


export default function Services(){
    return(
        <div className="services">
            <div className="servicesRowOne">
                <h1 className="title">Services</h1>
                <div className="overlay"/>
                <img loading="lazy" src={servicesPageBanner} className="services-banner-img"></img>
                {/* <video src={videoBG} autoPlay loop muted/> */}
                {/* <ServicesNav/> */}
            </div>
            
            <div className="servicesRowTwo">
                    {/* <ul className="advantagesList">
                        <li className="advantage">Advantage One</li>
                        <li className="advantage">Advantage Two</li>
                        <li className="advantage">Advantage Three</li>
                    </ul> */}

                    <div className="content">
                        <div className="context">
                            <h1 className="contextHead">Bixian Helps Brands <span>Grow Online</span>.</h1>
                            <p className="contextPara">
                            {/* Think of us as your digital marketing friends. We help businesses like yours grow online. We can do everything from cool social media stuff to making your website super easy to find. Our marketing experts are here to explain things simply and help you win online over time. We'll create a plan just for you, use the latest tricks, and work hard to make your brand a big hit. Let's work together to turn your online dreams into reality! */}
                            Bixian is your partner for comprehensive online growth. We craft engaging digital experiences, from impactful social media campaigns and strategic paid ads to intuitive website design and targeted messaging across platforms. Our experts drive visibility through SEO and compelling video content, nurture relationships with personalized email and influencer strategies, and deliver measurable results. Let's collaborate to build your brand's digital success.
                            </p>
                            <div>
                                <Link to='/about'><button>Discover About Bixian</button></Link>
                            </div>
                        </div>
                        <img loading="lazy" src={onlineGrowth} className="img" alt="img"/>
                    </div>
            </div>

            <div className="servicesRowThree">
                <h1 className="head">Our Services</h1>
                    <div className="servicesContainer">
                        <div className="serviceOne eachService">
                            <div className="context">
                                <h2 className="serviceHead">Social Media Marketing</h2>
                                <p className="serviceDescription">Spark conversations, build a loyal following, and watch your brand come alive across all platforms. Bixian crafts winning social media strategies to achieve your goals, keeping your audience engaged and coming back for more.</p>
                                
                                <a href="/services/socialmediamarketing"><button>Know More About Social Media Marketing</button></a>    
                                {/* <Link to='/services/socialmediamarketing'><button>Know More About Social Media Marketing</button></Link> */}
                            
                            </div>
                            <div className="imgHolder"><img loading="lazy" src={socialMediaMarketingImage} alt="service1" className="img serviceOneImg"/></div>
                        </div>

                        <div className="serviceTwo eachService">
                            <div className="imgHolder"><img loading="lazy" src={payPerClickAds} alt="service2" className="img serviceTwoImg"/></div>
                            <div className="context">
                                <h2 className="serviceHead">Pay-per Click Ads</h2>
                                <p className="serviceDescription">Laser-focused PPC campaigns put your brand in front of your ideal customers. Maximize impact, get discovered, and see your ROI soar with Bixian's expertise. Let Bixian target the right audience and stretch your advertising budget further.</p>

                                <a href="/services/payperclickads"><button>Know Morer About Pay-per Click Ads</button></a>
                                {/* <Link to='/services/payperclickads'><button>Know More About Pay-per Click Ads</button></Link> */}
                            
                            </div>
                        </div>

                        <div className="serviceThree eachService">
                            <div className="context">
                                <h2 className="serviceHead">Website Designing</h2>
                                <p className="serviceDescription">Make a lasting first impression. Bixian designs stunning and user-friendly websites that convert visitors into loyal customers. Elevate your online presence today with a website that not only looks great but drives results.</p>
                                
                                
                                <a href="/services/websitedesigning"><button>Know Morer About Website Designing</button></a>
                                {/* <Link to='/services/websitedesigning'><button>Know More About Website Designing</button></Link> */}

                            </div>
                            <div className="imgHolder"><img loading="lazy" src={websiteDevelopmentImage} alt="service3" className="img serviceThreeImg"/></div>
                        </div>

                        <div className="serviceFour eachService">
                            {/* <div className="imgHolder"><img loading="lazy" src={whatsAppMarketingBanner} alt="service4" className="img serviceFourImg"/></div> */}
                            <div className="imgHolder"><img loading="lazy" src={whatsAppMarketingBanner} alt="service4" className="img serviceFourImg"/></div>
                            <div className="context">
                                <h2 className="serviceHead">WhatsApp Marketing</h2>
                                <p className="serviceDescription">Engage your audience on a personal level with targeted promotions and direct communication through Bixian's WhatsApp marketing strategies. Build stronger relationships and boost sales with personalized messaging.</p>

                                <a href="/services/whatsappmarketing"><button>Know More About WhatsApp Marketing</button></a>
                                {/* <Link to='/services/whatsappmarketing'><button>Know More About WhatsApp Marketing</button></Link> */}

                            </div>
                        </div>

                        <div className="serviceFive eachService">
                            <div className="context">
                                <h2 className="serviceHead">Bulk SMS</h2>
                                <p className="serviceDescription">Reach a wide audience instantly. Bixian's cost-effective bulk SMS campaigns ensure your message gets noticed and drives engagement and sales. Send targeted blasts to promote special offers and keep your customers informed.</p>
                                
                                <a href="/services/bulksms"><button>Know More About Bulk SMS</button></a>
                                {/* <Link to='/services/bulksms'><button>Know More About Bulk SMS</button></Link> */}

                            </div>
                            <div className="imgHolder"><img loading="lazy" src={bulkSMS} alt="service5" className="img serviceFiveImg"/></div>
                        </div>

                        <div className="serviceSix eachService">
                            <div className="imgHolder"><img loading="lazy" src={videoAdsBanner} alt="service6" className="img serviceSixImg"/></div>
                            <div className="context">
                                <h2 className="serviceHead">Video Ads</h2>
                                <p className="serviceDescription">Tell your brand story in a captivating way with high-quality video ads crafted by Bixian. Grab attention, resonate with your audience, and leave a lasting impression. Let Bixian create videos that connect emotionally and drive action.</p>
                               
                               <a href="/services/videoads"><button>Know More About Video Ads</button></a>
                                {/* <Link to='/services/videoads'><button>Know More About Video Ads</button></Link> */}

                            </div>
                        </div>

                        <div className="serviceSeven eachService">
                            <div className="context">
                                <h2 className="serviceHead">Search Engine Optimization</h2>
                                <p className="serviceDescription">Get discovered organically! Bixian's SEO expertise optimizes your website to rank higher in search results, driving traffic and brand growth. Attract qualified leads organically and watch your website climb the search engine rankings.</p>
                                
                                <a href="/services/searchengineoptimization"><button>Know More About SEO</button></a>
                                {/* <Link to='/services/searchengineoptimization'><button>Know More About SEO</button></Link> */}

                            </div>
                            <div className="imgHolder"><img loading="lazy" src={searchEngineOptimization} alt="service7" className="img serviceSevenImg"/></div>
                        </div>

                        <div className="serviceSix eachService">
                            <div className="imgHolder"><img loading="lazy" src={emailMarketing} alt="service6" className="img serviceSixImg"/></div>
                            <div className="context">
                                <h2 className="serviceHead">Email Marketing</h2>
                                <p className="serviceDescription">Convert leads into loyal customers. Bixian designs targeted email marketing campaigns that build lasting relationships and nurture leads. Foster brand loyalty and drive conversions with personalized email marketing strategies.</p>
                                
                                <a href="/services/emailmarketing"><button>Know More About Email Marketing</button></a>
                                {/* <Link to='/services/emailmarketing'><button>Know More About Email Marketing</button></Link> */}

                            </div>
                        </div>

                        <div className="serviceSeven eachService">
                            <div className="context">
                                <h2 className="serviceHead">Influencer Marketing</h2>
                                <p className="serviceDescription">Tap into established audiences and amplify your brand message. Bixian's influencer marketing expertise connects you with the right partners to reach a wider audience. Partner with relevant influencers to gain credibility and reach a targeted audience.</p>
                                
                                <a href="/services/influencermarketing"><button>Know More About Influencer Marketing</button></a>
                                {/* <Link to='/services/influencermarketing'><button>Know More About Influencer Marketing</button></Link> */}

                            </div>
                            <div className="imgHolder"><img loading="lazy" src={influencerMarketing} alt="service7" className="img serviceSevenImg"/></div>
                        </div>                        
                    </div>
            </div>


            <div className="servicesRowFour">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Services?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>

        </div>
    )
}

